import type { FormulaErrorKey, FormulaToken } from '../../models/metric.types'

function adjacentError(current: FormulaToken, next: FormulaToken): FormulaErrorKey | null {
  const valueLike =
    current.type === 'metric' || current.type === 'number' || current.type === 'rparen'
  const nextValueLike = next.type === 'metric' || next.type === 'number' || next.type === 'lparen'
  if (valueLike && nextValueLike) return 'workspaceDefinitions.formula.error.missingOperator'
  if (current.type === 'op' && next.type === 'op') {
    return 'workspaceDefinitions.formula.error.doubleOperator'
  }
  return null
}

function parenError(tokens: readonly FormulaToken[]): FormulaErrorKey | null {
  let balance = 0
  for (const current of tokens) {
    if (current.type === 'lparen') balance += 1
    else if (current.type === 'rparen') balance -= 1
    if (balance < 0) return 'workspaceDefinitions.formula.error.unbalancedParens'
  }
  return balance === 0 ? null : 'workspaceDefinitions.formula.error.unbalancedParens'
}

export function validate(tokens: readonly FormulaToken[]): FormulaErrorKey | null {
  if (!tokens.length) return null
  const first = tokens[0]
  const last = tokens[tokens.length - 1]
  if (first?.type === 'op' && first.value !== '+' && first.value !== '-') {
    return 'workspaceDefinitions.formula.error.leadingOperator'
  }
  if (last?.type === 'op') return 'workspaceDefinitions.formula.error.trailingOperator'

  for (let index = 0; index < tokens.length - 1; index += 1) {
    const current = tokens[index]
    const next = tokens[index + 1]
    if (!current || !next) continue
    const error = adjacentError(current, next)
    if (error) return error
  }
  return parenError(tokens)
}
